<sub-header [includeContextHelp]="false" [isModal]="true" [windowHash]=windowHash>
</sub-header>
<!--<p-scrollPanel [style]="{width: '100%', height: '90vh'}" styleClass="custombar1">-->
<div class="container-fluid">
  <div class="row mt-5">
    <!-- ZONA DE DOCUMENTO  -->
    <div class="col-12">
      <!-- RENDERIZAR DOCUMENTO PDF -->
      <div *ngIf="this.fileItem && this.isPdf ()">
        <filePDFViewer [currentFile]="this.fileItem" [showExpandButton]="true" [showZoom]="true" [showPages]="true"
          [showToolbar]="true" [showRotation]="true" [showAllPagesDocument]="false">
        </filePDFViewer>
      </div>
      <!-- RENDERIZAR DOCUMENTO NO PDF -->
      <div *ngIf="this.fileItem && !this.isPdf()">
        <!-- CABECERA DE DOCUMENTO -->
        <div class="p-xs ui-toolbar rounded">
          <span class="leyenda">{{this.fileItem.name}}</span>
          <!--div class="ibox-tools float-right">
              <div [ngSwitch]="this.fileItem.name.toUpperCase().substring(this.fileItem.name.lastIndexOf('.')+1)"
                class="p-5">
                <div class="icon" *ngSwitchCase="'PDF'">
                  <a class="collapse-link" (click)="downloadFile(this.fileItem)" target="newwwindoe">
                    <i class="fas fa-download"></i>
                  </a>
                  <a class="close-link" (click)="printFile(this.fileItem)">
                    <i class="fa fa-print"></i>
                  </a> </div>
              </div>
            </div-->
        </div>
        <div class="">
          <div class="  text-center">
            <div [ngSwitch]="this.fileItem.name.toUpperCase().substring(this.fileItem.name.lastIndexOf('.')+1)"
              class="p-5">
              <div class="icon" *ngSwitchCase="'PDF'">
                <i class="fas fa-file-pdf fa-5x text-doc"></i>
              </div>
              <!--div class="icon" *ngSwitchCase="'XML'">
                      <i class="fas fa-file-code fa-5x text-doc"></i>
                    </div>
                    <div class="icon" *ngSwitchCase="'DOC'">
                      <i class="fas fa-file-word fa-5x text-doc"></i>
                    </div>
                    <div class="icon" *ngSwitchCase="'DOCX'">
                      <i class="fas fa-file-word fa-5x text-doc"></i>
                    </div-->
              <div class="text-center" *ngSwitchDefault>
                <!--i class="fas fa-file-code fa-5x text-doc"></i-->
                <button (click)="downloadFile(this.fileItem)" class="btn btn-white d-inline-block w-100 "><i
                    class="fas fa-download fa-5x text-doc"></i> </button>
                <span class="text-doc d-inline-block w-100">{{ 'FilePDFViewer.download' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN ZONA DOCUMENTO -->
  </div>
</div>
<!--</p-scrollPanel>-->